import { ExerciseCategory } from '../types/database'

export interface CategoryDisplay {
  id: ExerciseCategory
  name: string
  description: string
  icon: string
  color: string
  order: number
}

export const categories: CategoryDisplay[] = [
  {
    id: 'vocabulary',
    name: 'Vocabulary',
    description: 'Words and phrases by topic',
    icon: 'book-open',
    color: 'emerald',
    order: 1,
  },
  {
    id: 'grammar',
    name: 'Grammar',
    description: 'Rules, patterns, and structure',
    icon: 'academic-cap',
    color: 'indigo',
    order: 2,
  },
  {
    id: 'av-content',
    name: 'Content',
    description: 'Podcasts, shows, music, and movies',
    icon: 'play-circle',
    color: 'purple',
    order: 3,
  },
]

export function getCategoriesSorted(): CategoryDisplay[] {
  return [...categories].sort((a, b) => a.order - b.order)
}

export function getCategoryDisplay(id: ExerciseCategory): CategoryDisplay | undefined {
  return categories.find((c) => c.id === id)
}
